<template>
  <div class="in-body" v-if="hospAccount">
    <div class="page-left">
      <div class="panel">
        <div class="money-panel">
          <div class="panel-title">
            <span class="title-text">接收到的爱佑捐赠额 <span class="dw">（元）</span> </span>
            <img src="/static/history-money.png" alt="">
          </div>
          <span class="num">{{ totalAmount }}</span>
        </div>
        <div class="money-panel">
          <div class="panel-title">
            <span class="title-text">总救助人数 <span class="dw">（人）</span> </span>
            <img src="/static/history-people.png" alt="">
          </div>
          <span class="num">{{ totalPersonsCount }}</span>
        </div>
      </div>
      <div class="echarts-1">
        <div class="echarts-title">
          <div class="date-choose">
            <img src="/static/jt-down.png"  :style="{transform:pickerFocusI?'rotate(180deg)':''}" alt="">
            <el-date-picker
              v-model="defaultMoneyYear"
              type="year"
              format="yyyy年"
              @change="pickerChange($event,1)"
              @focus='yearPickerFocusM'
              @blur = 'yearPickerBlurM'
              placeholder="选择年">
            </el-date-picker>

          </div>
          <span class="title-text">年已执行的捐赠额 <span class="dw">（元）</span> </span>
        </div>
        <div class="echarts-view-center">
          <div class="offer">
            <div class="offer-top">
              <img src="/static/xin.png" alt="">
              <span>已执行</span>
            </div>
            <span class="num">{{ sumAmount }}</span>
          </div>
          <div class="pie-view">
            <div id="myChart" :style="{width: '8.802vw', height: '8.802vw'}"></div>
            <img src="/static/yang-icon.png" class="yang" alt="">
          </div>

          <div class="eChart-pie-data">
            <span class="data-title">捐赠额占比</span>
            <div class="date-item">
              <span class="name">先心病</span>
              <div class="date-num">
                <div class="bl" style="background-color: #FF8B64">{{ xxScale }}%</div>
                <div class="num">{{ xxAmountText }}</div>
              </div>
            </div>
            <div class="date-item">
              <span class="name">血液病</span>
              <div class="date-num">
                <div class="bl" style="background-color: #74C9FF">{{ xyScale }}%</div>
                <div class="num">{{ xyAmountText }}</div>
              </div>
            </div>
            <div class="date-item">
              <span class="name">出生缺陷</span>
              <div class="date-num">
                <div class="bl" style="background-color: #FFC664">{{ qxScale }}%</div>
                <div class="num">{{ qxAmountText }}</div>
              </div>
            </div>
          </div>
        </div>
        <div id="myChart1-bar" :style="{width: '100%',height: '38vh'}"></div>
      </div>
    </div>
    <div class="page-right">
      <div class="message">
        <div class="ts">
          <img src="/static/ts-icon.png" alt="">
          <span>提醒事项</span>
        </div>
        <div class="message-list">
          <div class="message-item">
            现有  <span @click="msgNumToPage(3)" :class="[headList[1]?'':'cannot-click']">{{ childNumData.cureNoSubmitCount }}</span>  个治疗费用、 <span @click="msgNumToPage(4)"  :class="[headList[2]?'':'cannot-click']">{{ childNumData.checkNoSubmitCount }}</span>  个检查费用需要填写，请尽快提交！
          </div>
          <div class="message-item">
            现有  <span @click="msgNumToPage(7)" :class="[headList[1]?'':'cannot-click']">{{ childNumData.cureTimeoutCount }}</span>  个治疗费用、 <span @click="msgNumToPage(8)"  :class="[headList[2]?'':'cannot-click']">{{ childNumData.checkTimeoutCount }}</span>  个检查费用填写超期了，请尽快提交！
          </div>
          <div class="message-item">
            现有  <span @click="msgNumToPage(9)" :class="[headList[3]?'':'cannot-click']">{{ childNumData.childPassCount }}</span> 个审核通过的患儿可以上传术后照片了，快点上传吧！
          </div>
          <div class="message-item">
            本院已注册患儿共有 <span @click="msgNumToPage(1)" :class="[headList[0]?'':'cannot-click']">{{ childNumData.childNoSubmitCount }}</span> 人没有提交申请资料，其中已有 <span @click="msgNumToPage(2)" :class="[headList[0]?'':'cannot-click']">{{ childNumData.childTimeoutCount }}</span> 人超期!
          </div>
          <div class="message-item">
            现有  <span @click="msgNumToPage(5)" :class="[headList[1]?'':'cannot-click']">{{ childNumData.cureReturnCount }}</span>  个治疗费用、 <span @click="msgNumToPage(6)"  :class="[headList[2]?'':'cannot-click']">{{ childNumData.checkReturnCount }}</span>  个检查费用，<span @click="msgNumToPage(10)"  :class="[headList[4]?'':'cannot-click']">{{ childNumData.proxyReturnCount }}</span> 个代申请被退回了，请尽快处理！
          </div>


        </div>
      </div>
      <div class="echarts-2">
        <div class="echarts-title">
          <div class="date-choose">
            <el-date-picker
              v-model="defaultCountYear"
              style="position: absolute"
              type="year"
              :style="{'opacity':'1'}"
              format="yyyy年"
              @change="pickerChange($event,2)"
              @focus='yearPickerFocus'
              @blur = 'yearPickerBlur'
              placeholder="选择年">
            </el-date-picker>
            <img src="/static/jt-down.png" :style="{transform:pickerFocusII?'rotate(180deg)':''}" alt="">
          </div>
          <span class="title-text">当年已救助人数 <span class="dw">（人）</span> </span>
        </div>
        <div class="people-num offer-top">
          <img src="/static/pn.png" alt="">
          <span>{{ sumCount }}</span>
        </div>
        <div id="myChart2-bar" :style="{width: '100%',height: '38vh'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getHospitalChildAndOutlayStatInfo, getHospitalTotalInfo, getHospitalYearStatInfo, getMenus} from "../util/api";

  export default {
    name: "home",
    data () {
      return {
        hospAccount:false,
        changeDate1:false,
        changeDate2:false,
        orgOptions: {},
        yearMoney:'',
        yearPeople:'',
        pickerFocusI:false,
        pickerFocusII:false,
        totalAmount: 0,
        totalPersonsCount: 0,
        childNumData: {},
        defaultMoneyYear:0,
        defaultCountYear:0,
        headList:[false,false,false,false,false],
        xxList:[],
        xyList:[],
        qxList:[],
        sumAmount:0,
        xxAmount:0,
        xyAmount:0,
        qxAmount:0,
        maxYL:0,
        moneyInterval: 1000,
        xxAmountText:'0',
        xyAmountText:'0',
        qxAmountText:'0',
        xxScale:0,
        xyScale:0,
        qxScale:0,
        xxCount:0,
        xyCount:0,
        qxCount:0,
        xxCountList:[],
        xyCountList:[],
        qxCountList:[],
        sumCountList:[],
        sumCount:0,
        maxY:0,
        childNumInterval: 1
      }
    },
    mounted(){
      // this.drawPie();
      // this.drawbar1();
      // this.drawbarPeople();

    },
    created() {
      if(this.$store.state.menu.length>0){
        if(window.localStorage.getItem('hospAccount')==='false'){
          this.hospAccount = false
          // setTimeout(()=>{
          //   console.log(this.$router)
          this.$router.push(this.$store.state.menu[0].path)
          // },1000)
        }else{
          this.hospAccount = true
          this.init()
        }
      }



    },
    watch:{
      '$store.state.menu'(ov){
        if (ov!=''){
          if(window.localStorage.getItem('hospAccount')==='false'){
            this.hospAccount = false
            this.$router.push(this.$store.state.menu[0].path)
          }else{
            this.hospAccount = true
            this.init()
          }
        }
      }
    },
    methods: {
      init(){
        let date = new Date()
        this.defaultMoneyYear = date
        this.defaultCountYear = date
        this.queryTotal()
        this.getHospitalChildAndOutlayStatInfo()
        this.getAmountByYear()
        this.getCountByYear()
        getMenus().then(res=>{
          let _list = res.responseData
          let _res = []
          res.responseData.forEach(item=>{
            if(item.items.length>0){
              _res = [..._res,item.items]
            }
          })
          window.localStorage.setItem("ayMenus", JSON.stringify(_res[0]));
          this.isChildRegister(_res[0])
          console.log(this.headList)
        })
      },
      isChildRegister(list){
        let that = this
        list.forEach(item=>{
          if(item.items.length>0){
            that.isChildRegister(item.items)
          }else{
            if(item.label=='患儿注册'){
              that.headList[0] = true
            }else if(item.label=='治疗费用填报'){
              that.headList[1] =  true
            }else if(item.label=='检查费用填报'){
              that.headList[2] =  true
            }else if(item.label=='患儿管理'){
              that.headList[3] =  true
            }else if(item.label=='患儿代申请'){
              that.headList[4] =  true
            }
          }
        })

      },
      queryTotal(){
        getHospitalTotalInfo().then(res=>{
          //
          this.totalAmount = this.changeTextFromNum(res.responseData.totalAmount,'amount')
          this.totalPersonsCount =  this.changeTextFromNum(res.responseData.totalPersonsCount,'count')
        })
      },
      changeTextFromNum(num,type){
        if(type=='count'){

          return  num.toLocaleString('en-US')
        }else if(type=='amount'){
          let amountStr = num.toLocaleString('en-US')
          if(amountStr.indexOf('.')>-1){
            let _count =  amountStr.toString().split(".")[1].length
            if(_count==1){
              amountStr+='0'
            }
          }else{
            amountStr+='.00'
          }

          return amountStr
        }
      },

      getAmountByYear(){
        this.xxAmount=0
        this.xyAmount=0
        this.qxAmount=0
        this.xxList=[]
        this.xyList=[]
        this.qxList=[]
        this.sumAmount = 0
        getHospitalYearStatInfo({yearValue:this.defaultMoneyYear.getFullYear()}).then(res=>{
          this.maxYL = 0;
          let _monthStat = res.responseData.monthStat

          for (let i = 0;i<12;i++){
            this.xxAmount += _monthStat[i].totalAmount
            this.xyAmount += _monthStat[i+12].totalAmount
            this.qxAmount += _monthStat[i+24].totalAmount
            this.xxList.push(_monthStat[i].totalAmount)
            this.xyList.push(_monthStat[i+12].totalAmount)
            this.qxList.push(_monthStat[i+24].totalAmount)
            if(_monthStat[i].totalAmount>this.maxYL)this.maxYL = _monthStat[i].totalAmount
            if(_monthStat[i+12].totalAmount>this.maxYL)this.maxYL =_monthStat[i+12].totalAmount
            if(_monthStat[i+24].totalAmount>this.maxYL)this.maxYL =_monthStat[i+24].totalAmount

          }
          if(this.maxYL==0) {
            this.maxYL=1000
          } else {
            let maxNum = Math.ceil(this.maxYL + (this.maxYL * 0.2));
            maxNum = maxNum - maxNum % 2000;
            this.maxYL = this.maxY < maxNum ? maxNum : maxNum + 2000;
          }
          this.maxYL = Math.ceil(this.maxYL / 5) * 5;
          let _amount = this.xxAmount + this.xyAmount + this.qxAmount
          this.sumAmount = this.changeTextFromNum(_amount,'amount')
          this.xxScale = this.xxAmount!=0?((this.xxAmount/_amount)*100).toFixed(1):0
          this.xyScale = this.xyAmount!=0?((this.xyAmount/_amount)*100).toFixed(1):0
          this.qxScale = this.qxAmount!=0?((this.qxAmount/_amount)*100).toFixed(1):0
          this.xxAmountText = this.changeTextFromNum(this.xxAmount,'amount')
          this.xyAmountText = this.changeTextFromNum(this.xyAmount,'amount')
          this.qxAmountText =  this.changeTextFromNum(this.qxAmount,'amount')
          this.drawbar1();
          this.drawPie()
        })
      },
      getCountByYear(){
        getHospitalYearStatInfo({yearValue:this.defaultCountYear.getFullYear()}).then(res=>{
          this.maxY = 0;
          this.sumCount=0
          this.xxCountList=[]
          this.xyCountList=[]
          this.qxCountList=[]
          this.sumCountList=[]
          let _monthStat = res.responseData.monthStat
          for (let i = 0;i<12;i++){
            this.sumCount+=(_monthStat[i].totalPersonsCount + _monthStat[i+12].totalPersonsCount + _monthStat[i+24].totalPersonsCount)
            this.xxCountList.push(_monthStat[i].totalPersonsCount)
            this.xyCountList.push(_monthStat[i+12].totalPersonsCount)
            this.qxCountList.push(_monthStat[i+24].totalPersonsCount)
            this.sumCountList.push(_monthStat[i].totalPersonsCount + _monthStat[i+12].totalPersonsCount + _monthStat[i+24].totalPersonsCount)

          }
          this.sumCountList.forEach(item=>{
            if(item>this.maxY)this.maxY = item

          })
          if(this.maxY <= 0) {
            this.maxY = 100
          } else {
            this.maxY = Math.ceil(this.maxY + (this.maxY * 0.2));
            this.maxY = Math.ceil(this.maxY / 5) * 5
          }

          this.sumCount= this.changeTextFromNum(this.sumCount,'count')
          this.drawbarPeople();
        })
      },
      getHospitalChildAndOutlayStatInfo(){
        getHospitalChildAndOutlayStatInfo().then(res=>{
          this.childNumData = res.responseData
        })
      },
      msgNumToPage(index){
        switch (index){
          case 1:
            if(!this.headList[0]) return
            this.$router.push({path:'/child/register',query:{isSubmit:'0'}})
            break;
          case 2:
            if(!this.headList[0]) return
            this.$router.push({path:'/child/register',query:{tap:'second'}})
            break;
          case 3:
            if(!this.headList[1]) return
            this.$router.push({path:'/outlay/cure',query:{tap:'todo'}})
            break;
          case 4:
            if(!this.headList[2]) return
            this.$router.push({path:'/outlay/check',query:{tap:'todo'}})
            break;
          case 5:
            if(!this.headList[1]) return
            this.$router.push({path:'/outlay/cure',query:{tap:'rollback'}})
            break;
          case 6:
            if(!this.headList[2]) return
            this.$router.push({path:'/outlay/check',query:{tap:'rollback'}})
            break;
          case 7:
            if(!this.headList[1]) return
            this.$router.push({path:'/outlay/cure',query:{tap:'timeout'}})
            break;
          case 8:
            if(!this.headList[2]) return
            this.$router.push({path:'/outlay/check',query:{tap:'timeout'}})
            break;
          case 9:
            if(!this.headList[3]) return
            this.$router.push({path:'/child/manage',query:{status:2,needPostoperaPhoto:1}})
            break;
          case 10:
            if(!this.headList[4]) return
            this.$router.push({path:'/child/hospital',query:{status:4,mode:2}})
            break;
        }
      },
      pickerChange(e,type){
        if(type==1){
          this.defaultMoneyYear = e
          this.changeDate1 = true
          this.getAmountByYear()
        }else{
          this.defaultCountYear = e
          this.changeDate2 = true
          this.getCountByYear()
        }
      },
      yearPickerFocusM(){
        this.pickerFocusI = true
      },
      yearPickerBlurM(){
        this.pickerFocusI = false
      },
      yearPickerFocus(){
        this.pickerFocusII = true
      },
      yearPickerBlur(){
        this.pickerFocusII = false
      },
      drawPie(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表
        myChart.setOption({
          animation:false,
          color: ['#FF8B64', '#74C9FF', '#FFC664',],
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: ['70%', '100%'],
              avoidLabelOverlap: false,
              label:{
                show:false
              },
              labelLine: {
                show: false
              },
              data: [
                {value: this.xxAmount},
                {value: this.xyAmount},
                {value: this.qxAmount},
              ]
            }
          ]
        });
      },
      drawbar1(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart1-bar'))
        // 绘制图表
        myChart.setOption({
          legend: {
            right:80,
            top:20
          },
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            data: ['01月', '02月', '03月', '04月', '05月', '06月', '07月', '08月', '09月', '10月', '11月', '12月'],
            axisPointer: {
              type: 'shadow'
            },
            axisLine:{       //y轴刻度线
              show:false
            },
            axisTick:{       //y轴刻度线
              show:false
            },
          },
          yAxis: {
            type:'value',
            min:0,
            max: this.maxYL,
            interval: this.maxYL / 5,
            axisLine:{       //y轴刻度线
              show:false
            },

            axisTick:{       //y轴刻度线
              show:false
            },
            splitLine: {
              show: true,
              lineStyle:{
                type:'dashed'
              }
            }

          },
          series: [
            {
              name: '先心病',
              type: 'bar',
              data: this.xxList,
              barWidth:7,
              itemStyle:{
                normal:{
                  color:"#FF8B64"
                }
              }
            },
            {
              name: '血液病',
              type: 'bar',
              data: this.xyList,
              barWidth:7,
              itemStyle:{
                normal:{
                  color:"#74C9FF"
                }
              }
            },
            {
              name: '出生缺陷',
              type: 'bar',
              data: this.qxList,
              barWidth:7,
              itemStyle:{
                normal:{
                  color:"#FFC664"
                }
              }
            },

          ]
        });
      },
      drawbarPeople(){
        let that = this
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart2-bar'))
        // 绘制图表
        myChart.setOption(

          {
            // grid:{
            //   tooltip: {
            //     trigger: 'axis',
            //     axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            //       type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            //     },
            //     formatter: function(data)
            //     {
            //       console.log(111)
            //       return data
            //     }
            //   },
            //
            // },

            legend: {
              data: ['先心病', '血液病', '出生缺陷'],
              right:80,
              top:20
            },

            xAxis: [
              {
                type: 'category',

                data: ['01月', '02月', '03月', '04月', '05月', '06月', '07月', '08月', '09月', '10月', '11月', '12月'],
                axisPointer: {
                  type: 'none',
                  show:true,
                },
                axisLine:{       //y轴刻度线
                  show:false
                },
                axisTick:{       //y轴刻度线
                  show:false
                },
              }
            ],
            yAxis: [
              {
                type: 'value',
                name: '',
                min: 0,
                // minInterval: 1,
                max: this.maxY,
                interval: this.maxY / 5,
                axisLine:{       //y轴刻度线
                  show:false
                },
                axisTick:{       //y轴刻度线
                  show:false
                },
                splitLine: {
                  show: true,
                  lineStyle:{
                    type:'dashed'
                  }
                },
                axisLabel: {
                  formatter: '{value}'
                }
              }
            ],

            tooltip: {
              trigger: 'axis',
              axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                snap:true,
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
              },
              // formatter: function(data)
              // {
              //   let _index = data.dataIndex
              //   let _title = '<span style="font-size: 12px">'+ (_index+1)+'月人数' + '<span/>' + '<br/>' +  that.sumCountList[data.dataIndex]
              //   let _htmlXX = '先心病:'+ that.xxCountList[data.dataIndex]
              //   let _htmlXY = '血液病:'+ that.xyCountList[data.dataIndex]
              //   let _htmlQX = '出生缺陷:'+ that.qxCountList[data.dataIndex]
              //   let _html = _title+'<br/>' +  _htmlXX + '<br/>' + _htmlXY + '<br/>' + _htmlQX
              //   return _html
              // }
            },
            series: [

              {
                name: '先心病',
                type: 'bar',
                data: this.xxCountList,
                barWidth:7,
                itemStyle:{
                  normal:{
                    color:"#FF8B64"
                  }
                }
              },
              {
                name: '血液病',
                type: 'bar',
                data:this.xyCountList,
                barWidth:7,
                itemStyle:{
                  normal:{
                    color:"#74C9FF"
                  }
                }
              },
              {
                name: '出生缺陷',
                type: 'bar',
                data: this.qxCountList,
                barWidth:7,
                itemStyle:{
                  normal:{
                    color:"#FFC664"
                  }
                }
              },
              {
                name: '当月总数',
                type: 'line',
                smooth: true,
                yAxisIndex: 0,
                data: this.sumCountList
              }
            ]
          });
      }

    }
  }
</script>

<style lang="scss" scoped>
  body{
    overflow-y: hidden;
    .content{
      background: rgba(0,0,0,0) !important;
    }
  }
  @font-face {
    font-family: FjallaOne; //自定义字体名称
    src: url('../assets/font/FjallaOne-Regular-2.ttf'); //注意引入正确位置
  }
  /deep/ .el-input__suffix{
    display: none;
  }
  .in-body{
    width: 100%;
    height: calc(100vh  - 95px);
    overflow-y: hidden;
    min-height: 100%;
    display: flex;

    .page-left{
      display: flex;
      height:100%;
      width: 49.5%;
      flex-direction: column;
      //margin-bottom: 1.042vw;
      .panel{
        display: flex;
        align-items: center;
        width: 100%;

        justify-content: space-between;
        .money-panel{
          width: 49%;
          height: 22vh;
          background: rgba(255,255,255,.88);
          box-shadow:1px 1px 7px 11px #c5c5c51a;
          border-radius: 0.313vw;
          .panel-title{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 1.042vw;
            .title-text{
              font-size: 1.146vw;
              font-family: PingFang SC;
              font-weight: 800;
              color: #333333;
              margin-left: 1.563vw;
              .dw{
                font-size: 0.833vw;
                color:#999999;
              }
            }

            img{
              width: 2.708vw;
              margin-right: 1.094vw;
              height: 2.708vw;
            }
          }
          .num{
            //font-size: 2.813vw;
            font-size: 36px;
            display: block;
            font-family: FjallaOne;
            font-weight: 400;
            color: #333333;
            margin-left: 1.563vw;
            margin-top: 2vh;
          }

        }
      }

      .echarts-1{
        width: 100%;
        height:calc(100vh - 22vh - 1.094vw);
        margin-top: 1.094vw;
        background: rgba(255,255,255,.88);
        box-shadow:1px 1px 7px 11px #c5c5c51a;
        border-radius: 0.313vw;
        position: relative;
        .echarts-title{

          display: flex;
          margin-left: 1.563vw;
          align-items: center;
          margin-top: 1.563vw;
          /deep/ .date-choose{
            position: relative;
            width: 5.156vw;
            height: 1.563vw;
            border: 0.052vw solid #333333;
            //opacity: 0.3;
            border-radius: 0.781vw;
            cursor: pointer;
            display: flex;
            justify-content: center;
            font-size: 0.729vw;
            color: #333333;
            align-items: center;
            .el-input{
              z-index: 5;
              .el-input__inner{
                border: none;
                outline: none;
                width:  100%;
                height: 1.563vw;
                color: #333333;
                text-align: center;
                padding: 0 8px 0 0;
                background: none;

              }
              .el-input__prefix{
                display: none;
              }
            }

            img{
              width: 8px;
              height: 5px;
              position: absolute;
              z-index: 1;
              right:5px;
            }
          }
          .title-text{
            font-size: 1.146vw;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333333;
            margin-left: 1.563vw;
            .dw{
              font-size: 0.833vw;
              color:#999999;
            }
          }

        }
        .echarts-view-center{
          margin-left: 1.563vw;
          display: flex;
          margin-top: 0.938vw;
          .offer{
            width: 18vw;
            .offer-top{
              display: flex;
              align-items: center;
              img{
                width: 2.708vw;
                height: 2.708vw;
              }
              span{
                font-size: 0.833vw;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
                margin-left: 0.677vw;
              }
            }
            .num{
              font-size: 36px;
              display: block;
              font-family: FjallaOne;
              font-weight: 400;
              color: #333333;
              margin-top: 0.729vw;
            }
          }
          .pie-view{
            width: 8.802vw;
            margin-top: -1vw;
            height: 8.802vw;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #myChart{
              position: absolute;
            }
            .yang{
              width: 2.083vw;
              height: 2.604vw;
              z-index: 1;
            }
          }

        }
        .eChart-pie-data{
          margin-left: 1.667vw;
          margin-top: -2vw;
          .data-title{
            font-size: 0.938vw;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333333;
            margin-bottom: 1.042vw;
            display: block;
          }
          .date-item{
            display: flex;
            flex-direction: column;
            margin-top: 0.26vw;
            .name{
              font-size: 0.729vw;
              font-family: PingFangSC;
              font-weight: 400;
              color: #333333;
            }
            .date-num{
              display: flex;
              margin-top: 2px;
              align-items: center;
              .num{
                font-size: 0.833vw;
                font-family: HelveticaNeueCE;
                font-weight: normal;
                color: #333333;
                margin-left: 5px;
              }
              .bl{
                width: 3.55vw;
                height: 1.042vw;
                padding-left: 5px;
                font-size: 0.833vw;
                font-family: HelveticaNeueCE;
                font-weight: bold;
                color: #FFFFFF;
              }
            }

          }
        }
        #myChart1-bar{
          position: absolute;
          bottom: -1vw;
        }


      }
    }

    .page-right{
      display: flex;
      flex-direction: column;
      width: 49.5%;
      height: 100%;
      margin-left: 1%;
      .message{
        width: 100%;
        height: 45vh;
        background: rgba(255,255,255,0.88);
        box-shadow:1px 1px 7px 11px #c5c5c51a;
        border-radius: 0.313vw;
        display: flex;
        .ts{
          display: flex;
          flex-direction: column;
          margin: 1.615vw 2vw 0 2vw;
          align-items: center;

          img{
            width: 4.167vw;
            height: 4.167vw;
          }
          span{
            font-size: 1.146vw;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333333;
            line-height: 2.813vw;
          }
        }
        .message-list{
          margin-top: 1.042vw;
          width:75%;
          .message-item{
            width:100%;
            height: 2.604vw;
            font-size: 0.833vw;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333333;
            line-height: 2.813vw;
            border-bottom: #d4d4d4 0.052vw dashed;
            span{
              color:#E8556F;
              font-size: 1.25vw;
              font-style: italic;
              text-underline: #E8556F;
              text-decoration:underline;
              cursor: pointer;
            }
            .cannot-click{
              text-decoration:none;
              cursor: none;
            }
          }
        }


      }
      .echarts-2{
        width: 100%;
        height: calc(100vh - 35vh - 0.99vw);
        background: rgba(255,255,255,0.88);
        box-shadow:1px 1px 7px 11px #c5c5c51a;
        border-radius: 0.313vw;
        margin-top: 0.99vw;
        position: relative;
        .echarts-title{
          display: flex;
          margin-left: 1.563vw;
          align-items: center;
          margin-top: 1.563vw;
          /deep/ .date-choose{
            width: 5.156vw;
            height: 1.563vw;
            border: 0.052vw solid #333333;
            position: relative;
            //opacity: 0.3;
            border-radius: 0.781vw;
            display: flex;
            justify-content: center;
            font-size: 0.729vw;
            cursor: pointer;
            color: #333333;
            align-items: center;
            .el-input{
              z-index: 5;
              .el-input__inner{
                border: none;
                outline: none;
                width:  100%;
                height: 1.563vw;
                color: #333333;
                text-align: center;
                padding: 0 8px 0 0;
                background: none;
              }
              .el-input__prefix{
                display: none;
              }
            }

            img{
              width: 8px;
              height: 5px;
              position: absolute;
              z-index: 1;
              right:5px;
            }
          }
          .title-text{
            font-size: 1.146vw;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333333;
            margin-left: 1.563vw;
            .dw{
              font-size: 0.833vw;
              color:#999999;
            }
          }

        }
        .people-num{
          font-size: 36px;
          font-family: FjallaOne;
          font-weight: 400;
          margin-left: 1.615vw;
          margin-top: 1.042vw;
          color: #333333;
          display: flex;
          align-items: center;
          img {
            width: 2.708vw;
            height: 2.708vw;
          }
          span {
            margin-left: 0.677vw;
          }
        }
        #myChart2-bar{
          //margin-top: -2vw;
          position: absolute;
          //margin-top: 2vw;
          bottom: -1vw;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue